import { CPagination } from './CPagination.js';
import { CPaginationItem } from './CPaginationItem.js';

const CPaginationPlugin = {
    install: (app) => {
        app.component(CPagination.name, CPagination);
        app.component(CPaginationItem.name, CPaginationItem);
    },
};

export { CPagination, CPaginationItem, CPaginationPlugin };
//# sourceMappingURL=index.js.map
